import { useEffect, useState } from 'react';
import { Microphone } from 'tabler-icons-react';
import { StoryAccordionTitle, Button } from 'Elements';
import styles from 'partials/story-box.module.scss';

export const SidebarStoryDescription = ({ text, persons, onShowMore }) => {
	const [showMore, setShowMore] = useState(false);

	useEffect(() => {
		const rawText = text.replace(/<(.|\n)*?>/g, '');
		setShowMore(rawText.length > 250);
	}, [text]);

	return (
		<div className={styles.box}>
			<StoryAccordionTitle
				isOpen
				title={persons}
				icon={Microphone}
				hasExpand={false}
			/>
			<div className={styles.wrapper}>
				<div
					className={styles.text}
					dangerouslySetInnerHTML={{
						__html:
							text.length > 250
								? text.substring(0, 250) + '...'
								: text
					}}
				/>
				{showMore && (
					<div className={styles.more}>
						<Button
							className={styles.moreButton}
							onClick={onShowMore}>
							متن کامل
						</Button>
					</div>
				)}
			</div>
		</div>
	);
};
